"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partialWithOptions = exports.partial = void 0;
// @ts-ignore
const caster_1 = require("./caster");
function partial(declaration, candidate) {
    if (arguments.length === 0) {
        return partial;
    }
    else if (arguments.length === 1) {
        return (c) => partial(declaration, c);
    }
    return partialWithOptions(declaration, {}, candidate);
}
exports.partial = partial;
function partialWithOptions(declaration, options, candidate) {
    if (arguments.length === 0) {
        return partialWithOptions;
    }
    else if (arguments.length === 1) {
        return (o) => (c) => partialWithOptions(declaration, o, c);
    }
    const caster = caster_1.createCaster(declaration, options);
    const { invalidations, isValid } = caster(candidate);
    if (declaration.type === 'Object') {
        if (isValid === false && invalidations.some(([path, type, rule]) => path.length === 0 && rule === 'type')) {
            return invalidations;
        }
        if (typeof candidate !== 'object' || candidate === null) {
            return invalidations;
        }
        const propKeys = Object.keys(candidate);
        return invalidations.filter(([path, type, rule]) => {
            if (path.length === 0) {
                return true;
            }
            const [propkey] = path;
            return propKeys.includes(propkey);
        });
    }
    return invalidations;
}
exports.partialWithOptions = partialWithOptions;
